import Vue from 'vue'
import VueRouter from 'vue-router'
import VueHead from 'vue-head'
import AccountLogin from '../views/AccountLogin.vue'
import AdminContainer from "../views/AdminContainer.vue"
import NotFound from '../views/NotFound.vue'

// Admin pages
import Dashboard from '../views/ADMIN/Dashboard/index.vue';
import Settings from "../views/ADMIN/Settings/index.vue";
import Streaming from "../views/ADMIN/Streaming/index.vue";
import Finance from "../views/ADMIN/Finance/index.vue";
import Members from "../views/ADMIN/Members/index.vue";
import Chat from "../views/ADMIN/SupportChat/index.vue";
import Channels from "../views/ADMIN/Channels/index.vue";
import Ads from "../views/ADMIN/Ads/index.vue"

// Streamer admin
import s_Dashboard from "../views/STREAMER/Dashboard/index.vue";
import s_Audio_Visual from "../views/STREAMER/AudioVisual/index.vue"
import s_Stream from "../views/STREAMER/Stream/index.vue";
import s_Pricing from "../views/STREAMER/Pricing/index.vue";
import s_Customization from "../views/STREAMER/Customization/index.vue";
import s_Voting from "../views/STREAMER/Voting/index.vue";
import s_Events from "../views/STREAMER/Events/index.vue";
import s_Donation from "../views/STREAMER/Donation/index.vue";

// Scanner
const Scanner = () => import(/* webpackPrefetch: true */ "../views/scanner.vue")
const TicketSaller = () => import(/* webpackPrefetch: true */ "../views/TicketSeller.vue")

// Participant
const ParticipantLogin = () => import(/* webpackPrefetch: true */ "../views/PARTICIPANT/Login.vue")
const ParticipantDashboard = () => import(/* webpackPrefetch: true */ "../views/PARTICIPANT/Dashboard.vue")


Vue.use(VueRouter)
Vue.use(VueHead);
const routes = [{
    path: '/login',
    name: 'login',
    component: AccountLogin,
},
{
    path: '/scanner',
    name: 'scanner',
    component: Scanner
},
{
    path: '/ticket/saller',
    name: 'ticket_saller',
    component: TicketSaller
},
{
    path: '/',
    name: 'AdminContainer',
    component: AdminContainer,
    children: [
        {
            path: '',
            name: 'welcome',
            component: Dashboard,
        },
        {
            path: '/dashboard',
            name: 'dashboard',
            component: Dashboard,
        },
        {
            path: "/chat/:id?",
            name: 'chat_support',
            component: Chat
        },
        {
            path: "/finance/:tab?",
            name: 'finance',
            component: Finance
        },
        {
            path: "/ads/:tab?",
            name: 'ads',
            component: Ads
        },
        {
            path: "/channels/:tab?",
            name: 'channels',
            component: Channels
        },
        {
            path: "/streaming/:tab?",
            name: 'streaming',
            component: Streaming
        },
        {
            path: "/members/:tab?",
            name: 'members',
            component: Members
        },
        {
            path: "/settings/:tab?",
            name: 'settings',
            component: Settings
        },
        // Streamer routes
        {
            path: "/streamer/dashboard/:tab?",
            name: 's_dashboard',
            component: s_Dashboard
        },
        {
            path: "/streamer/audiovisual/:tab?",
            name: 's_audiov',
            component: s_Audio_Visual
        },
        {
            path: "/streamer/stream/:tab?",
            name: 's_stream',
            component: s_Stream
        },
        {
            path: "/streamer/voting/:tab?",
            name: 's_voting',
            component: s_Voting
        },
        {
            path: "/streamer/events/:tab?",
            name: 's_events',
            component: s_Events
        },
        {
            path: "/streamer/donation/:tab?",
            name: 's_donation',
            component: s_Donation
        },
        {
            path: "/streamer/pricing/:tab?",
            name: 's_pricing',
            component: s_Pricing
        },
        {
            path: "/settings/customization/:tab?",
            name: 'settings_customization',
            component: s_Customization
        },
    ]
},

// Participant routes
{
    path: '/participant/login/:id',
    name: 'participant_login',
    component: ParticipantLogin,
},
{
    path: '/participant/dashboard/:tab?',
    name: 'participant_dashboard',
    component: ParticipantDashboard,
},

// Not found page
{
    path: '*',
    component: NotFound,
    name: 'notfound',
}
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    duplicateNavigationPolicy: 'ignore',
})

export default router